import React, { Component } from "react";
import { connect } from "react-redux";

import { Wrapper, Icon } from "app/NativeComponents/common";
import GoogleMapReact, { Polyline } from "google-map-react";

import { getMapOptions } from "./MapStyles";

import { renderGlidePolygon, renderHighlights } from "./Polygons";

import { renderCurrentRoute, renderRoutes } from "./Routes";

import { getDistance } from "geolib";

import CustomMarker from "app/DealMachineCore/components/PropertyMap/CustomMarker";
import MapTop from "app/DealMachineCore/components/PropertyMap/MapTop";
import MapBottom from "app/DealMachineCore/components/PropertyMap/MapBottom";
import EndRouteModal from "app/DealMachineCore/components/PropertyMap/EndRouteModal";
import GlidePin from "app/DealMachineCore/components/PropertyMap/GlidePin";

import {
  checkIfCoordinatesAreInProperty,
  checkIfPropertyInBounds,
  renderRouteColor,
  determineHighlightArray,
  getShownProperties,
  checkIfShowMarker,
  getCurrentRouteSections,
  combineRouteSections
} from "app/DealMachineCore/components/PropertyMap/MapActions";

import {
  getMapProperties,
  updateMapLocation,
  addDeal,
  selectActiveProperty,
  getReverseGeocode,
  toggleTapToAdd,
  lockLocationTracking,
  editPropertyMapOptions,
  toggleShowRoutes,
  toggleMapType,
  setLastLocation,
  switchMapMode,
  getMyLocation,
  dismissMobileKeyboard
} from "app/NativeActions";

const default_lat = 39.97411;
const default_lng = -86.11756;

class Map extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isMapReady: false,
      show_map_options: false,
      update_to_coordinates: {
        latitude: null,
        longitude: null
      },
      map_region_properties: {
        center: {
          //latitude: this.props.user.user_default_lat ? parseFloat(this.props.user.user_default_lat) : default_lat,
          //longitude: this.props.user.user_default_lng ? parseFloat(this.props.user.user_default_lng) : default_lng,
          latitude: props.update_map_location
            ? props.update_map_location.latitude
            : props.last_location
            ? props.last_location.latitude
            : props.user
            ? props.user.user_default_lat
              ? parseFloat(props.user.user_default_lat)
              : default_lat
            : default_lat,
          longitude: props.update_map_location
            ? props.update_map_location.longitude
            : props.last_location
            ? props.last_location.longitude
            : props.user
            ? props.user.user_default_lng
              ? parseFloat(props.user.user_default_lng)
              : default_lng
            : default_lng
        },
        heading: props.update_map_location
          ? props.update_map_location.heading
          : props.last_location
          ? props.last_location.heading
          : 0,
        pitch: 0,
        zoom: 19,
        altitude: 0
      },
      last_fetch_location: {
        latitude: props.update_map_location
          ? props.update_map_location.latitude
          : props.last_location
          ? props.last_location.latitude
          : props.user
          ? props.user.user_default_lat
            ? parseFloat(props.user.user_default_lat)
            : default_lat
          : default_lat,
        longitude: props.update_map_location
          ? props.update_map_location.longitude
          : props.update_map_location
          ? props.last_location.longitude
          : props.user
          ? props.user.user_default_lng
            ? parseFloat(props.user.user_default_lng)
            : default_lng
          : default_lng,
        heading: props.update_map_location
          ? props.update_map_location.heading
          : props.last_location
          ? props.last_location.heading
          : 0
      },
      maxHighlightZoomOut: 15.5,
      maxZoomOut: 17.5,
      minZoomInProperies: 18.5,
      showZoomMessage: false,
      showHighlightZoomMessage: false,
      routeZoomMax: false,
      maxRouteZoomOut: 12,
      pin_location: null,
      is_pan_dragging: false,
      is_map_moving: false,
      highlight_array: [],
      current_route_coordinates: [],
      combined_routes: []
    };
  }

  toggleIsPanDraging(toggle) {
    if (this.state.is_pan_dragging != toggle) {
      this.setState({ is_pan_dragging: toggle });
    }
  }

  toggleIsRegionChanging(toggle) {
    if (this.state.is_region_changing != toggle) {
      this.setState({ is_region_changing: toggle });
    }
  }

  componentDidMount() {
    if (this.state.map_region_properties) {
      if (
        this.state.map_region_properties.center.latitude &&
        this.state.map_region_properties.center.longitude
      ) {
        //get properties
        this.getProperties({
          region: this.state.map_region_properties,
          load_type: "mount"
        });
      }
    }
  }

  shouldComponentUpdate(prevProps, prevState) {
    if (
      prevProps.map_properties != this.props.map_properties ||
      prevProps.map_routes != this.props.map_routes ||
      prevState.highlight_array != this.props.highlight_array ||
      prevState.current_route_coordinates !=
        this.props.current_route_coordinates ||
      prevState.combined_routes != this.props.combined_routes ||
      prevProps.property_map_options != this.props.property_map_options ||
      prevProps.current_route != this.props.current_route ||
      prevProps.current_route_section != this.props.current_route_section ||
      prevProps.track_route != this.props.track_route ||
      prevProps.map_routes != this.props.map_routes ||
      prevProps.open != this.props.open ||
      prevProps.map_mode != this.props.map_mode ||
      prevState.map_region_properties != this.state.map_region_properties ||
      prevProps.active_property != this.props.active_property ||
      prevProps.is_search_bar_focused != this.props.is_search_bar_focused ||
      prevState.isMapReady != this.state.isMapReady ||
      prevProps.last_location != this.props.last_location ||
      prevProps.update_map_location != this.props.update_map_location ||
      prevProps.lock_location_tracking != this.props.lock_location_tracking
    ) {
      return true;
    }

    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.map_properties != this.props.map_properties ||
      prevProps.property_map_options != this.props.property_map_options ||
      prevProps.applied_highlights != this.props.applied_highlights
    ) {
      const highlight_array = determineHighlightArray(
        this.props.map_properties,
        this.props.property_map_options,
        this.props.user
      );
      this.setState({
        highlight_array: highlight_array
      });

      renderHighlights(this.state.google_map, highlight_array);
    }

    if (
      (prevProps.current_route_section != this.props.current_route_section ||
        prevProps.current_route != this.props.current_route ||
        prevProps.track_route != this.props.track_route) &&
      this.props.track_route
    ) {
      const current_route_coordinates = getCurrentRouteSections(
        this.props.current_route_section,
        this.props.current_route
      );

      this.setState({
        current_route_coordinates: current_route_coordinates
      });
    }
    if (prevProps.map_routes != this.props.map_routes) {
      //const combined_routes = combineRouteSections(this.props.map_routes);
      this.setState({
        combined_routes: this.props.map_routes
      });
    }

    if (
      prevProps.property_map_options != this.props.property_map_options ||
      prevProps.applied_highlights !== this.props.applied_highlights
    ) {
      this.getProperties({ load_type: "refresh" });
    }

    //render polygons
    /*
    if(this.props.active_property != prevProps.active_property ||
    this.props.map_mode != prevProps.map_mode){
      renderGlidePolygon(this.state.google_map, this.props.active_property, this.props.map_mode);
    }
    */

    //render polylins
    if (
      this.state.combined_routes != prevState.combined_routes ||
      this.props.show_routes != prevProps.show_routes
    ) {
      renderRoutes(
        this.state.google_map,
        this.state.combined_routes,
        this.props.user,
        this.props.show_routes
      );
    }

    if (
      this.state.current_route_coordinates !=
        prevState.current_route_coordinates ||
      this.props.show_routes != prevProps.show_routes
    ) {
      renderCurrentRoute(
        this.state.google_map,
        this.props.current_route_coordinates,
        this.props.show_routes
      );
    }

    //mode changed
    if (prevProps.map_mode != this.props.map_mode) {
      this.updatePinLocation(null);
      this.props.selectActiveProperty(this.props.token, null);
    }

    if (prevProps.isMobile !== this.props.isMobile) {
      this.props.switchMapMode("pin");
    }

    if (!this.props.isMobile && this.props.user.team_clearance_level > 0) {
      if (
        this.props.active_property &&
        this.props.active_property !== prevProps.active_property
      ) {
        if (
          this.props.match.params.property_id !==
          this.props.active_property.property_id
        ) {
          this.props.appRedirect({
            redirect: "property",
            payload: {
              property_id: this.props.active_property.property_id,
              map: this.props.user.team_clearance_level > 0 ? true : false,
              page_id: null
            }
          });
        }
      }
    }

    //property map did move
    if (prevState.map_region_properties && this.state.map_region_properties) {
      //set max zoom
      if (
        this.state.map_region_properties.zoom < this.state.maxZoomOut &&
        this.state.showZoomMessage == false
      ) {
        this.setState({ showZoomMessage: true });
      } else if (
        this.state.map_region_properties.zoom >= this.state.maxZoomOut &&
        this.state.showZoomMessage == true
      ) {
        this.setState({ showZoomMessage: false });
      }

      //set highlight max zoom
      if (
        this.state.map_region_properties.zoom <
          this.state.maxHighlightZoomOut &&
        this.state.showHighlightZoomMessage == false
      ) {
        this.setState({ showHighlightZoomMessage: true });
      } else if (
        this.state.map_region_properties.zoom >=
          this.state.maxHighlightZoomOut &&
        this.state.showHighlightZoomMessage == true
      ) {
        this.setState({ showHighlightZoomMessage: false });
      }

      //set route max zoom
      if (
        this.state.map_region_properties.zoom < this.state.maxRouteZoomOut &&
        this.state.routeZoomMax == false
      ) {
        this.setState({ routeZoomMax: true });
      } else if (
        this.state.map_region_properties.zoom >= this.state.maxRouteZoomOut &&
        this.state.routeZoomMax == true
      ) {
        this.setState({ routeZoomMax: false });
      }

      if (
        prevState.map_region_properties.center.latitude !=
          this.state.map_region_properties.center.latitude ||
        prevState.map_region_properties.center.longitude !=
          this.state.map_region_properties.center.longitude ||
        prevState.map_region_properties.zoom !=
          this.state.map_region_properties.zoom
      ) {
        //get properties
        this.getProperties({
          region: this.state.map_region_properties,
          zoomChange:
            prevState.map_region_properties.zoom !=
            this.state.map_region_properties.zoom
              ? true
              : false
        });
      }
    }

    if (prevState.current_route != null && this.props.current_route == null) {
      this.getProperties({
        region: this.state.map_region_properties
      });
    }

    if (prevProps.update_map_location == null) {
      if (this.props.update_map_location != null) {
        this.changeMapLocation(this.props.update_map_location);
      }
    } else if (
      this.props.update_map_location &&
      prevProps.update_map_location
    ) {
      if (
        this.props.update_map_location.latitude !=
          prevProps.update_map_location.latitude ||
        this.props.update_map_location.longitude !=
          prevProps.update_map_location.longitude ||
        this.props.update_map_location.heading !=
          prevProps.update_map_location.heading
      ) {
        this.changeMapLocation(this.props.update_map_location);
      }
    }

    //update location to new pin?
    if (
      this.props.active_property &&
      !this.props.lock_location_tracking &&
      this.props.map_mode != "glide" &&
      this.props.map_mode != "tap_to_add" &&
      prevProps.active_property == null
    ) {
      this.changeMapLocation(this.props.active_property.location);
    }

    //glide mode check
    if (this.props.map_mode == "glide" && prevProps.map_mode != "glide") {
      this.getActivePropertyFromGlide({
        latitude: this.state.map_region_properties.center.latitude,
        longitude: this.state.map_region_properties.center.latitude,
        latitudeDelta: this.state.map_region_properties.latitudeDelta,
        longitudeDelta: this.state.map_region_properties.longitudeDelta
      });
    }

    if (
      prevState.isMapReady != this.state.isMapReady &&
      this.props.map_properties.length > 1
    ) {
      if (this.state.map_region_properties) {
        if (
          this.state.map_region_properties.center.latitude &&
          this.state.map_region_properties.center.longitude
        ) {
          //get properties
          this.getProperties({
            region: this.state.map_region_properties,
            load_type: "mount"
          });
        }
      }
    }
  }

  getActivePropertyFromGlide(region) {
    let property = checkIfCoordinatesAreInProperty(
      region,
      this.props.map_properties
    );
    if (property) {
      this.props.selectActiveProperty(this.props.token, property);
    } else {
      this.props.selectActiveProperty(this.props.token, null);
      this.getProperties({
        ...this.state.map_region_properties,
        center: {
          latitude: region.latitude,
          longitude: region.longitude
        },
        latitudeDelta: region.latitudeDelta,
        longitudeDelta: region.longitudeDelta
      });
    }
  }

  changeMapLocation(location) {
    if (location && !this.state.is_map_moving) {
      if (this.state.google_map) {
        this.state.google_map.setCenter(
          new window.google.maps.LatLng(
            parseFloat(location.latitude),
            parseFloat(location.longitude)
          )
        );
      }
    }
  }

  componentWillUnmount() {
    //clearInterval(this._get_properties_interval);
    //clearInterval(this._redraw_markers_interval);
    clearInterval(this._drawer_toggle_interval);
    clearInterval(this._track_map_moving);
  }

  getProperties({
    region = this.state.map_region_properties,
    load_type = "",
    zoomChange = false
  }) {
    if (
      (!this.props.map_properties_loading || load_type == "mount") &&
      !this.state.routeZoomMax &&
      (getDistance(this.state.last_fetch_location, region.center) > 75 ||
        load_type == "refresh" ||
        load_type == "mount" ||
        zoomChange ||
        this.props.map_properties.length == 0) &&
      region.longitudeDelta &&
      region.latitudeDelta
    ) {
      const bounds = {
        westLng: region.center.longitude - region.longitudeDelta / 2, // westLng - min lng
        southLat: region.center.latitude - region.latitudeDelta / 2, // southLat - min lat
        eastLng: region.center.longitude + region.longitudeDelta / 2, // eastLng - max lng
        northLat: region.center.latitude + region.latitudeDelta / 2,
        centerLat: region.center.latitude,
        centerLng: region.center.longitude
      };

      this.setState({
        last_fetch_location: {
          latitude: region.center.latitude,
          longitude: region.center.longitude
        }
      });
      //give it a second for the map to finish moving
      //clearInterval(this._get_properties_interval);
      //this._get_properties_interval = setTimeout(()=>{

      this.props.getMapProperties({
        token: this.props.token,
        load_type: load_type == "mount" ? "refresh" : load_type,
        map_type:
          this.state.map_region_properties.zoom < this.state.maxZoomOut &&
          this.state.map_region_properties.zoom >=
            this.state.maxHighlightZoomOut
            ? "highlights_only"
            : this.state.map_region_properties.zoom <
              this.state.maxHighlightZoomOut
            ? "routes"
            : "map",
        bounds: bounds,
        limit: 200,
        filters: this.props.applied_highlights,
        dont_include_properties: this.props.map_properties
          ? this.props.map_properties.length > 0
            ? this.props.map_properties
                .map(property => {
                  return property.from_data_source == "melissa"
                    ? property.from_data_source_id
                    : "0";
                })
                .join()
            : ""
          : "",
        dont_include_deals: this.props.map_properties
          ? this.props.map_properties.length > 0
            ? this.props.map_properties
                .map(property => {
                  return property.deal ? property.deal.id : "0";
                })
                .join()
            : ""
          : "",
        dont_include_route_sections: this.props.current_route
          ? this.props.current_route.route_sections
            ? this.props.current_route.route_sections
                .map(section => {
                  return section.section_id;
                })
                .join()
            : ""
          : ""
      });

      //}, 500);
    }
  }

  onMapReady(map, maps) {
    this.setState({
      isMapReady: true,
      google_map: map
    });
  }

  updatePinLocation(coordinates) {
    this.setState({
      pin_location: coordinates
    });
  }

  renderMapPin(coordinates) {
    if (coordinates) {
      if (coordinates.latitude && coordinates.longitude) {
        return (
          <div
            key={"pin"}
            ref={"pin"}
            style={{
              marginTop: "-10px",
              marginLeft: "-10px"
            }}
            lat={parseFloat(coordinates.latitude)}
            lng={parseFloat(coordinates.longitude)}
            onClick={e => {
              e.stopPropagation();
            }}
          >
            <Icon icon="add" size={20} />
          </div>
        );
      }
    }
  }

  zoomToMin() {
    this.setState({
      map_region_properties: {
        ...this.state.map_region_properties,
        zoom: this.state.maxZoomOut
      }
    });
  }

  handleZoomControl(type) {
    var maxZoom = 20;
    var minZoom = 12;
    if (type === "zoom-in" && this.state.map_region_properties.zoom < maxZoom) {
      this.setState({
        map_region_properties: {
          ...this.state.map_region_properties,
          zoom: this.state.map_region_properties.zoom + 1
        }
      });
      this.getProperties({ region: this.state.map_region_properties });
    } else if (
      type === "zoom-out" &&
      this.state.map_region_properties.zoom > minZoom
    ) {
      this.setState({
        map_region_properties: {
          ...this.state.map_region_properties,
          zoom: this.state.map_region_properties.zoom - 1
        }
      });
      this.getProperties({ region: this.state.map_region_properties });
    }
  }

  propertyPressed(property) {
    //get property from property array
    let pressed_property;
    this.props.map_properties.map(p => {
      if (p.id == property.id) {
        pressed_property = property;
      }
      return p;
    });

    if (pressed_property) {
      this.props.selectActiveProperty(this.props.token, pressed_property);
      if (!this.props.isMobile && this.props.user.team_clearance_level > 0) {
        this.props.appRedirect({
          redirect: "property",
          payload: {
            property_id: property.property_id,
            map: this.props.user.team_clearance_level > 0 ? true : false,
            page_id: null
          }
        });
      }

      if (this.props.map_mode == "tap_to_add") {
        //add property
        if (
          !pressed_property.deal &&
          !this.props.add_deal_loading.some(
            loading_property =>
              loading_property.property_id == pressed_property.property_id
          )
        ) {
          this.props.addDeal({
            token: this.props.token,
            property: pressed_property,
            route_id: this.props.current_route
              ? this.props.current_route.route_id
              : 0,
            address: pressed_property.property_address,
            address2: pressed_property.property_address2,
            city: pressed_property.property_address_city,
            state: pressed_property.property_address_state,
            zip: pressed_property.property_address_zip
          });
        }
      }
    }
  }

  render() {
    if (
      this.state.map_region_properties.center.latitude &&
      this.state.map_region_properties.center.longitude
    ) {
      return (
        <Wrapper style={{ flex: 1, position: "relative" }}>
          <div
            className="deal-map-container"
            style={{
              flex: 1
            }}
          >
            <GoogleMapReact
              id="dealmachine-property-map"
              ref="map"
              yesIWantToUseGoogleMapApiInternals={true}
              bootstrapURLKeys={{
                key: "AIzaSyBKxAXFBe8TSxxLFX6jDKxZdTu8-rdv_6s"
              }}
              center={{
                lat: this.state.map_region_properties.center.latitude,
                lng: this.state.map_region_properties.center.longitude
              }}
              zoom={this.state.map_region_properties.zoom}
              onZoomAnimationEnd={zoom => {
                this.setState({
                  map_region_properties: {
                    ...this.state.map_region_properties,
                    zoom: zoom
                  }
                });
              }}
              options={getMapOptions(
                this.props.map_type,
                this.props.dark_mode == "dark_mode" ? true : false,
                false
              )}
              onGoogleApiLoaded={({ map, maps }) => {
                this.onMapReady(map, maps);
              }}
              onClick={e => {
                if (
                  e &&
                  this.state.maxHighlightZoomOut <
                    this.state.map_region_properties.zoom &&
                  this.props.map_mode != "glide"
                ) {
                  //place pin on map
                  this.updatePinLocation({
                    latitude: e.lat,
                    longitude: e.lng
                  });

                  let property = checkIfCoordinatesAreInProperty(
                    {
                      latitude: e.lat,
                      longitude: e.lng
                    },
                    this.props.map_properties
                  );

                  if (property) {
                    this.propertyPressed(property);
                  } else {
                    //unset properties...reverse geocode with google api
                    //double check property database with parsed item otherwise display the property address
                    //and a way to look up owner
                    if (this.props.map_mode != "tap_to_add") {
                      this.props.selectActiveProperty(this.props.token, null);

                      this.props.getReverseGeocode({
                        token: this.props.token,
                        coordinate: {
                          latitude: e.lat,
                          longitude: e.lng
                        }
                      });
                    }
                  }
                }
              }}
              onChange={({ center, bounds }) => {
                if (center) {
                  const longitudeDelta = Math.abs(
                    bounds.se.lng - bounds.nw.lng
                  );
                  const latitudeDelta = Math.abs(bounds.se.lat - bounds.nw.lat);

                  this.props.updateMapLocation({ coordinates: null });
                  this.props.setLastLocation({
                    coordinates: {
                      latitude: center.lat,
                      longitude: center.lng
                    }
                  });

                  this.setState({
                    map_region_properties: {
                      ...this.state.map_region_properties,
                      center: {
                        latitude: center.lat,
                        longitude: center.lng
                      },
                      latitudeDelta: latitudeDelta,
                      longitudeDelta: longitudeDelta
                    }
                  });
                }
              }}
              onDrag={map => {
                //hide all active properties in bottom preview

                this.updatePinLocation(null);
                if (!this.props.lock_location_tracking) {
                  this.toggleIsPanDraging(true);
                }

                if (this.props.lock_location_tracking) {
                  this.props.lockLocationTracking(false);
                }

                if (this.props.map_mode != "glide") {
                  if (
                    this.props.isMobile ||
                    parseInt(this.props.user.team_clearance_level) === 0
                  ) {
                    this.props.selectActiveProperty(this.props.token, null);
                  }
                } else {
                  const bounds = map.getBounds();
                  const longitudeDelta = Math.abs(
                    bounds.getNorthEast().lat() - bounds.getSouthWest().lng()
                  );
                  const latitudeDelta = Math.abs(
                    bounds.getNorthEast().lng() - bounds.getSouthWest().lat()
                  );
                  this.getActivePropertyFromGlide({
                    latitude: map.getCenter().lat(),
                    longitude: map.getCenter().lng(),
                    longitudeDelta,
                    latitudeDelta
                  });
                }
              }}
              onDragEnd={() => {
                this.toggleIsPanDraging(false);
              }}
              //draggable={!this.props.lock_location_tracking}
              mapTypeId={this.props.map_type}
            >
              {this.renderMapPin(this.state.pin_location)}

              {
                //propery markers on map
                this.state.map_region_properties.zoom >=
                  this.state.maxZoomOut &&
                  this.props.map_properties.map((property, i) => {
                    //if(this.state.map_region_properties.zoom >= this.state.minZoomInProperies || property.deal){

                    if (
                      checkIfPropertyInBounds(
                        property,
                        this.state.map_region_properties
                      )
                    ) {
                      return (
                        <div
                          lat={property.location.latitude}
                          lng={property.location.longitude}
                          style={{
                            marginTop: "-10px",
                            marginLeft: "-10px"
                          }}
                          key={"property_" + property.property_id}
                          ref={"property_" + property.property_id}
                          onClick={e => {
                            dismissMobileKeyboard();

                            //fix for android
                            if (e && this.props.map_mode != "glide") {
                              if (e.nativeEvent) {
                                this.updatePinLocation(null);
                                this.propertyPressed(property);
                              }
                            }
                          }}
                        >
                          <CustomMarker
                            showPropertyMarker={true}
                            property_map_options={
                              this.props.property_map_options
                            }
                            add_deal_loading={this.props.add_deal_loading}
                            active_property={this.props.active_property}
                            property={property}
                            user={this.props.user}
                            zoom={this.state.map_region_properties.zoom}
                          />
                        </div>
                      );
                    }
                    //}
                    return null;
                  })
              }
            </GoogleMapReact>
            <GlidePin {...this.props} />
          </div>

          <MapTop
            toggleIsPanDraging={this.toggleIsPanDraging.bind(this)}
            handleZoomControl={this.handleZoomControl.bind(this)}
          />
          <MapBottom
            getProperties={this.getProperties.bind(this)}
            showZoomMessage={this.state.showZoomMessage}
            showHighlightZoomMessage={this.state.showHighlightZoomMessage}
            routeZoomMax={this.state.routeZoomMax}
            is_pan_dragging={this.state.is_pan_dragging}
            zoomToMin={this.zoomToMin.bind(this)}
            pin={this.state.pin_location}
            refreshMap={() => {}}
          />

          <EndRouteModal {...this.props} />
        </Wrapper>
      );
    }

    return <Wrapper />;
  }
}

const mapStateToProps = ({
  auth,
  drawer,
  route,
  settings,
  property_map,
  property,
  map,
  native,
  filter
}) => {
  const { token, user } = auth;
  const { open } = drawer;
  const { dark_mode, colors } = settings;
  const { window_width, window_height, isMobile } = native;
  const {
    map_routes,
    current_route,
    current_route_id,
    current_route_section,
    show_routes,
    track_route
  } = route;
  const {
    map_properties_loading,
    map_properties_error,
    map_properties,
    update_map_location,
    last_location,
    active_property,
    active_address,
    reverse_geocode_loading,
    reverse_geocode_address,
    add_deal_loading,
    map_mode
  } = property_map;

  const { applied_highlights } = filter;

  const { property_map_options } = property;

  const { map_type, lock_location_tracking } = map;

  return {
    token,
    user,
    open,
    dark_mode,
    colors,
    window_width,
    window_height,
    isMobile,

    map_routes,
    current_route,
    current_route_id,
    current_route_section,
    show_routes,
    track_route,

    map_properties_loading,
    map_properties_error,
    map_properties,

    map_type,
    lock_location_tracking,

    update_map_location,
    last_location,
    active_property,
    active_address,

    reverse_geocode_loading,
    reverse_geocode_address,

    add_deal_loading,
    map_mode,

    property_map_options,

    applied_highlights
  };
};

export default connect(mapStateToProps, {
  getMapProperties,
  updateMapLocation,
  getReverseGeocode,
  addDeal,
  selectActiveProperty,
  toggleTapToAdd,
  lockLocationTracking,
  editPropertyMapOptions,
  toggleShowRoutes,
  toggleMapType,
  setLastLocation,
  switchMapMode
})(Map);
